export default __webpack_public_path__ + "static/media/Pistol_6.d817e66f.png";